export enum GroupActionResponse {
    GROUP_CREATED = "GROUP_CREATED",
    GROUP_UPDATED = "GROUP_UPDATED",
    GROUP_DELETED = "GROUP_DELETED"
}

